import React, { useEffect, useState } from "react";
import * as Yup from "yup";
import "./profile.css";
import { SnackbarUI, useSnackbar } from "../header/snackbarProvider";
import { ErrorMessage, Field, Form, Formik } from "formik";
import SelectPicker from "../selectpicker/selectPicker";
import ConfirmationDialog from "../header/confirmation.dialog";
import { getProfessionalInfoById, getUserInfo, ProfessionalInfoDto, submitProfessionalInfoAdd, submitProfessionalInfoUpdate } from "../../services/profile.service";


const professionalInfoValidationSchema = Yup.object({
  totalYearsOfExperience: Yup.string().required("Total years in profession is required"),
  currentTechnology: Yup.string().required("Current technology focus is required"),
  title: Yup.string().required("Title is required"),
  employer: Yup.string().required("Employer is required"),
  employerType: Yup.string().required("Employer Type is required")
});


const technologyOptions = [
  { value: "advanced-rf-microwave-devices", label: "Advanced RF Microwave devices" },
  { value: "airborne-radar", label: "Airborne Radar" },
  { value: "antenna", label: "Antenna" },
  { value: "antennas-miniaturization", label: "Antennas Miniaturization" },
  { value: "cognitive-radar", label: "Cognitive Radar" },
  { value: "electromagnetism", label: "Electromagnetism" },
  { value: "extra-terrestrial-communications", label: "Extra-terrestrial Communications" },
  { value: "firefighting-robotic-vehicle", label: "Firefighting Robotic Vehicle" },
  { value: "microwave-imaging", label: "Microwave Imaging" },
  { value: "millimetre-wave-integrated-circuits", label: "Millimetre-wave Integrated Circuits" },
  { value: "passive-radar-imaging", label: "Passive Radar Imaging" },
  { value: "precipitation-scattering", label: "Precipitation Scattering" },
  { value: "radar", label: "Radar" },
  { value: "radar-adas", label: "Radar for Advanced Driver Assistance Systems" },
  { value: "radar-interference", label: "Radar Interference" },
  { value: "radar-range-equation", label: "Radar Range Equation" },
  { value: "radar-system-concepts", label: "Radar System Concepts and Signal Processing" },
  { value: "radar-tracking", label: "Radar Tracking" },
  { value: "radio-frequency", label: "Radio Frequency" },
  { value: "remote-sensing", label: "Remote Sensing" },
  { value: "rf-components", label: "RF Components" },
  { value: "sample-radar-systems", label: "Sample Radar Systems" },
  { value: "wave-propagation", label: "Wave Propagation" },
  { value: "wearable-radar", label: "Wearable Radar" },
  { value: "wireless-communication", label: "Wireless Communication" },
];


const titleOptions = [
  { value: "Chairman of the Board/President/CEO", label: "Chairman of the Board/President/CEO" },
  { value: "Chief Engineer/Chief Scientist", label: "Chief Engineer/Chief Scientist" },
  { value: "Scientist", label: "Scientist" },
  { value: "Sr. Scientist", label: "Sr. Scientist" },
  { value: "Technical Officer", label: "Technical Officer" },
  { value: "Sr. Technical Assistant", label: "Sr. Technical Assistant" },
  { value: "Consultant", label: "Consultant" },
  { value: "Dean/Professor/Instructor", label: "Dean/Professor/Instructor" },
  { value: "Design Engineer", label: "Design Engineer" },
  { value: "Design Engineering Manager", label: "Design Engineering Manager" },
  { value: "Engineering Manager", label: "Engineering Manager" },
  { value: "General Manager", label: "General Manager" },
  { value: "Hardware Engineer", label: "Hardware Engineer" },
  { value: "Member of Technical Staff", label: "Member of Technical Staff" },
  { value: "Owner/Partner", label: "Owner/Partner" },
  { value: "Retired", label: "Retired" },
  { value: "Scientific Manage", label: "Scientific Manager" },
  { value: "Software Engineer", label: "Software Engineer" },
  { value: "V.P. Engineering/Director Engineering", label: "V.P. Engineering/Director Engineering" },
  { value: "V.P. Operations", label: "V.P. Operations" },
  { value: "Other Professional/Technical", label: "Other Professional/Technical" }
];

const employerTypeOptions = [
  { value: "Academia", label: "Academia" },
  { value: "Government", label: "Government" },
  { value: "Industry", label: "Industry" },
  { value: "Retired", label: "Retired" },
  { value: "Other", label: "Other" }
];

const totalYearsOptions = [
  { value: "0", label: "Less than 1" },
  ...Array.from({ length: 9 }, (_, i) => ({ value: String(i + 1), label: String(i + 1) })),
  { value: "11", label: "10 or more" },
];



const ProfessionalInfoComponent = () => {

    const { showSnackbar, snackbar } = useSnackbar();
    const [usePersonalInfo, setUserPersonalInfo] = useState("");
    const [useProfessionalInfo, setUserProfessionalInfo] = useState("");
    const [openProfConfirmationDialog, setOpenProfConfirmationDialog] = useState(false);
    const [dialogValues, setDialogValues] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [showLoadingModal, setShowLoadingModal] = useState(false);

     //Using explit mode states for preview and update for clarity
     const [isPreviewMode, setIsPreviewMode] = useState(false);
     const [isUpdateMode, setIsUpdateMode] = useState(false);


    const handleProfDialogClose = () => {
      setOpenProfConfirmationDialog(false);
      setIsSubmitting(false); // Re-enable submit button
    };

      const [initialValuesOfProfessionalInfo, setInitialValuesOfProfessionalInfo] = useState({
        totalYearsOfExperience: "", 
        currentTechnology: "",
        title: "",
        employer: "",
        employerType: ""
      });


        useEffect(() => {
                    const fetchData = async () => {
                      try {
                        const userInfoDetails = await getUserInfo();
                        if (userInfoDetails && userInfoDetails.length > 0) {
                          const userInfo = userInfoDetails[0];
                          setUserPersonalInfo(userInfo);
                
                          const userProfessionalDetails = await getProfessionalInfoById(userInfo.loginId);
                          if (userProfessionalDetails && Object.keys(userProfessionalDetails).length > 0) {
                            setUserProfessionalInfo(userProfessionalDetails);
                            setInitialValuesOfProfessionalInfo({
                              totalYearsOfExperience: userProfessionalDetails.totalExp ?? "",  
                              currentTechnology: userProfessionalDetails.currentTechnology ?? "",
                              title: userProfessionalDetails.title ?? "",
                              employer: userProfessionalDetails.employer ?? "",
                              employerType: userProfessionalDetails.employerType ?? ""
                            });
                            // Show preview if data exists
                            setIsPreviewMode(true);
                            setIsUpdateMode(false);
                          } else {
                            // No data exists, show form directly
                            setIsPreviewMode(false);
                            setIsUpdateMode(false);
                          }
                        }
                      } catch (error) {
                        console.error("Error fetching professional-info details:", error);
                      }
                    };
                  
                    fetchData();
                  }, []);


        
        
  const handleProfessionalInfoSubmit = async (values, { setSubmitting, validateForm }) => {
     const errors = await validateForm();
     if (Object.keys(errors).length > 0) {
         setSubmitting(false);
        return;
      }
        
      setIsSubmitting(true);
      setOpenProfConfirmationDialog(true);
      setDialogValues(values);
  };
        
  const handleProfessionalInfoDialogConfirm = async () => {
    setOpenProfConfirmationDialog(false);
        
     if (isSubmitting) {
         setIsLoading(true);
         setShowLoadingModal(true);
        
         try {
          let action = useProfessionalInfo && Object.keys(useProfessionalInfo).length > 0 ? "update" : "add";
        
              const professionalInfoDto = new ProfessionalInfoDto(
                action === "update" ? useProfessionalInfo.professionalInfoId : "",
                usePersonalInfo.loginId,
                dialogValues.title,
                dialogValues.employerType,
                dialogValues.employer,
                dialogValues.totalYearsOfExperience,
                dialogValues.currentTechnology
              );
        
              const result =
                action === "update"
                  ? await submitProfessionalInfoUpdate(professionalInfoDto)
                  : await submitProfessionalInfoAdd(professionalInfoDto);
        
              if (result) {
                const userProfessionalDetails = await getProfessionalInfoById(usePersonalInfo.loginId);
                if (userProfessionalDetails && Object.keys(userProfessionalDetails).length > 0) {
                  setUserProfessionalInfo(userProfessionalDetails);
                  setInitialValuesOfProfessionalInfo({
                    totalYearsOfExperience: userProfessionalDetails.totalExp ?? "",
                    currentTechnology: userProfessionalDetails.currentTechnology ?? "",
                    title: userProfessionalDetails.title ?? "",
                    employer: userProfessionalDetails.employer ?? "",
                    employerType: userProfessionalDetails.employerType ?? ""
                  });
                   // After successful submission, show preview
                   setIsPreviewMode(true);
                   setIsUpdateMode(false);
                }
        
                // Scroll up before showing snackbar
                window.scrollTo({ top: 0, behavior: 'smooth' });
                showSnackbar(
                  action === "add"
                    ? "Professional info added successfully!"
                    : "Professional info updated successfully!",
                  "success"
                );
              } else {
                // Scroll up before showing snackbar
                window.scrollTo({ top: 0, behavior: 'smooth' });
                showSnackbar(
                  action === "add"
                    ? "Failed to add professional info."
                    : "Failed to update professional info.",
                  "danger"
                );
              }
            } catch (error) {
              console.error("Error handling professional info:", error);
              window.scrollTo({ top: 0, behavior: 'smooth' });
              showSnackbar("Error occurred while processing professional info.", "danger");
            } finally {
              setIsLoading(false);
              setShowLoadingModal(false);
              setIsSubmitting(false);
            }
          }
        };
        
        const handleEditClick = () => {
          // Switch to update mode (form with pre-filled data) if edit button is clicked
          setIsPreviewMode(false);
          setIsUpdateMode(true);
        };
        
  
    return (
        <>
  <div className="profile-master">

     {/* Render the Snackbar UI here at the top of the page */}
     {snackbar.open && <SnackbarUI message={snackbar.message} type={snackbar.type} />}


  {isPreviewMode && !isUpdateMode ? (
      <div className="profile-content">
      <div className="profile-info-preview">
        <h4>Professional Experience Information</h4>
        <div className="preview-content-container">
          <div className="preview-grid">
            <div className="preview-item">
              <span className="preview-label">Total years in profession:</span>
              <span className="preview-value">
              {useProfessionalInfo.totalExp !== null && useProfessionalInfo.totalExp !== undefined
              ? (
                  Number(useProfessionalInfo.totalExp) >= 10
                  ? (totalYearsOptions.find(opt => opt.value === "11")?.label || "")
                  : (totalYearsOptions.find(opt => opt.value === String(useProfessionalInfo.totalExp))?.label || "")
                )
               : ""
               }
               </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Current technology focus:</span>
              <span className="preview-value">
              {useProfessionalInfo.currentTechnology
                  ? (technologyOptions.find(
                 (opt) => opt.value === useProfessionalInfo.currentTechnology
                 )?.label || "")
               : ""}
                </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Title:</span>
              <span className="preview-value">
              {useProfessionalInfo.title
                  ? (titleOptions.find(
                 (opt) => opt.value === useProfessionalInfo.title
                 )?.label || "")
               : ""}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Employer Type:</span>
              <span className="preview-value">
              {useProfessionalInfo.employerType
                  ? (employerTypeOptions.find(
                 (opt) => opt.value === useProfessionalInfo.employerType
                 )?.label || "")
               : ""}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Employer:</span>
              <span className="preview-value">
               {useProfessionalInfo.employer}
              </span>
            </div>
          </div>
          <button 
            type="button" 
            className="btn btn-warning mt-4"
            onClick={handleEditClick}
          >
            Edit
          </button>
        </div>
      </div>
    </div>
      ) : (



     <Formik
            initialValues={initialValuesOfProfessionalInfo}
            enableReinitialize={true}
            validationSchema={professionalInfoValidationSchema}
            validateOnBlur={true}
            validateOnChange={true}
            onSubmit={handleProfessionalInfoSubmit}
          >
            {({ values, touched, errors, setFieldValue,setFieldTouched }) => (
              <Form style={{ width: "100%", maxWidth: "100%" }}>
           <div className="profile-content">
                <div className="row">
                  <div className="col-md-4 mb-3">
                  <SelectPicker
                   name="totalYearsOfExperience"
                   key={String(values.totalYearsOfExperience)} 
                   options={totalYearsOptions}
                   value={totalYearsOptions.find((opt) => opt.value === String(values.totalYearsOfExperience ?? "")) || ""}
                   handleChange={(selectedOption) => setFieldValue("totalYearsOfExperience", selectedOption?.value || "")}
                   label="Total years in profession"
                   required={true}
                   error={touched.totalYearsOfExperience && errors.totalYearsOfExperience ? errors.totalYearsOfExperience : ""}
                   touched={touched.totalYearsOfExperience}
                   setFieldTouched={setFieldTouched}
                  />
                <ErrorMessage name="totalYearsOfExperience" component="div" className="invalid-feedback" />
          
                  </div>
                  <div className="col-md-4 mb-3">
                  <SelectPicker
                  name="currentTechnology"
                  key={values.currentTechnology} 
                  options={technologyOptions}
                  value={technologyOptions.find((opt) => opt.value === values.currentTechnology) || null} 
                  handleChange={(selectedOption) => setFieldValue("currentTechnology", selectedOption?.value || "")}
                  label="Current technology focus"
                  required={true}
                  error={touched.currentTechnology && errors.currentTechnology ? errors.currentTechnology : ""}
                  touched={touched.currentTechnology}
                  setFieldTouched={setFieldTouched}
               />

                      <ErrorMessage name="currentTechnology" component="div" className="invalid-feedback" />
                    </div>
                  <div className="col-md-4 mb-3">
                      <SelectPicker
                        name="title"
                         key={values.title} 
                        options={titleOptions}
                        value={titleOptions.find((opt) => opt.value === values.title) || null} 
                        handleChange={(selectedOption) => setFieldValue("title", selectedOption?.value || "")}
                        label="Title"
                        required={true}
                        error={touched.title && errors.title ? errors.title : ""}
                        touched={touched.title}
                        setFieldTouched={setFieldTouched}
                      />
                      <ErrorMessage name="title" component="div" className="invalid-feedback" />
                    </div>
                </div>

                <div className="row">

            <div className="col-md-4 mb-3">
            <SelectPicker
              name="employerType"
              key={values.employerType} 
              options={employerTypeOptions}
              value={employerTypeOptions.find((opt) => opt.value === values.employerType)  || null} 
              handleChange={(selectedOption) => setFieldValue("employerType", selectedOption?.value || "")}
              label="Employer Type"
              required={true}
              error={touched.employerType && errors.employerType ? errors.employerType : ""}
              touched={touched.employerType}
              setFieldTouched={setFieldTouched}
           />
           <ErrorMessage name="employerType" component="div" className="invalid-feedback" />
        </div>

        <div className="col-md-4 mb-3">
                <div className="form-floating">
              <Field 
                type="text" 
                id="employer" 
                name="employer" 
                className={`form-control ${touched.employer && errors.employer ? "is-invalid" : ""}`}
                placeholder="Employer" 
                maxLength={250} 
              />
              <label htmlFor="employer">Employer<span className="required-input">*</span></label>
              <ErrorMessage name="employer" component="div" className="invalid-feedback" />
            </div>
            </div>


                </div>
      </div>
              
      <div className="btn-div">
      <button type="submit" className={`btn ${isUpdateMode ? "btn edit" : "btn add"}`}>
  {isUpdateMode ? "Update" : "Submit"}
</button>

    </div>  
              </Form>
            )}
          </Formik>

)}

              
          <ConfirmationDialog
        open={openProfConfirmationDialog}
        onClose={handleProfDialogClose}
        onConfirm={handleProfessionalInfoDialogConfirm}
        title=""
        message="Are you sure to submit?"
      />

  </div>

  {showLoadingModal && (
  <div className="loading-overlay">
    <div className="loading-container">
      <div className="loading-header">Processing...</div>
      <div className="loading-body">
        <div className="spinner-border text-primary loading-spinner" role="status"></div>
        <p className="mt-3">Please wait...</p>
      </div>
    </div>
  </div>
)}
       



       </>
  )
}
export default ProfessionalInfoComponent;

